@if (!user?.image) {
  <div
    class="d-flex justify-content-center align-items-center text-primary"
    [ngStyle]="sharedStyle"
  >
    <strong [ngStyle]="{ 'font-size': fontSize }">{{
      user?.nameInitialsImage
    }}</strong>
  </div>
}

@if (user?.image) {
  <img
    onStock
    [src]="user?.image ?? ''"
    [ngStyle]="sharedStyle"
    style="object-fit: cover"
  />
}
